import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { Table, Column, Button } from '@smartplatform/ui';
import store from '../../store';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

@observer
export default class List extends React.Component {

	@observable records = null;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.records = await store.model.Committee.find({
			include: [
				{ relation: 'deputies', scope: { fields: { id: true }}}
			],
			order: 'id asc'
		});
	};
	
	create = () => this.props.history.push('/admin/committees/create');
	
	count = committee => committee.deputies().length;

	renderDeactivated = record => record.deactivated && <FontAwesomeIcon icon={faCheck}/>;
	
	render() {
		let content = '...';
		
		if (this.records) {
			content = <Table records={this.records} rootPath="/admin">
				<Column property="id" width={60} label="id" />
				<Column property="name" width={340} label="Наименование" />
				<Column computed={this.count} label="Членов комитета" />
				<Column computed={this.renderDeactivated} label="В архиве" />
			</Table>;
		}
		
		return <div className="deputies-list">
			<p>Комитеты и комиссия</p>
			<p><Button className="btn-primary" onClick={this.create}>Создать</Button></p>
			{content}
		</div>;
	}
	
}
